module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/sunlight.e4b5113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/sunlight.jpg
// module id = Ffga
// module chunks = 0